import { useTranslation } from "react-i18next";

const BRANDS = [
  { name: "Amazon", url: "https://www.amazon.it" },
  { name: "SHEIN", url: "https://www.shein.com" },
  { name: "Temu", url: "https://www.temu.com" },
  { name: "Apple", url: "https://www.apple.com" },
  { name: "Samsung", url: "https://www.samsung.com" },
  { name: "Nike", url: "https://www.nike.com" },
  { name: "Revolut", url: "https://www.revolut.com" },
  { name: "PayPal", url: "https://www.paypal.com" },
  { name: "Google", url: "https://www.google.com" },
  { name: "Zalando", url: "https://www.zalando.it" },
];

export const BrandStrip = () => {
  const { i18n } = useTranslation();
  const it = i18n.language?.startsWith("it");
  const row = [...BRANDS, ...BRANDS];
  return (
    <section className="bg-[#0b0b0b] border-y border-[#D4AF37]/15 py-7 sm:py-9" data-testid="brand-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-[10px] sm:text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
          {it ? "In affiliazione con i migliori brand globali" : "In affiliation with leading global brands"}
        </p>
        <div className="relative overflow-hidden" aria-label={it ? "Brand in affiliazione" : "Affiliate brands"}>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#0b0b0b] to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#0b0b0b] to-transparent z-10" />
          <div className="if-marquee-track flex whitespace-nowrap w-max">
            {[0, 1].map((half) => (
              <div key={half} className="flex items-center">
                {row.map((b, i) => (
                  <a
                    key={`${half}-${i}`}
                    href={b.url}
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    aria-label={b.name}
                    title={b.name}
                    data-testid={`brand-${b.name.toLowerCase()}`}
                    className="px-7 sm:px-10 font-display text-lg sm:text-2xl font-extrabold tracking-tight text-white/45 hover:text-[#D4AF37] transition-colors"
                  >
                    {b.name}
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
